import React, {FC} from "react";
import moment from "moment";
import {Button} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {blue, red} from "@ant-design/colors";
import classNames from "classnames";
import {renderAmount} from "../../../../../../../../helpers/renderAmount";
import {BookingPostKind, Currency, PaymentProvider} from "../../../../../../../../generated/graphql";
import {postRowLabel, rateLabel} from "../../../../../../../../helpers/bookingPostKind";
import {PaymentItemProps} from "./types";
import css from "../RenderPaymentList.less";
import Spin from "../../../../../../../../views/Spin/Spin";
import PaymentMethodBadge from "../../../../../../../../views/PaymentMethodBadge/PaymentMethodBadge";

const PaymentItem: FC<PaymentItemProps> = ({
    payment,
    rowIndex,
    position,
    kind = BookingPostKind.CourseFee,
    onEdit,
    onDelete,
    showEditControls,
    currency,
    loading,
}) => {
    return (
        <div id={payment.id} className={css.listItem}>
            <div className={css.firstLine}>
                <div className={classNames(css.monthOfDueContainer)}>
                    {/* {loading && <Spin size="small" style={{fontSize: 8, marginLeft: -10}} />} */}
                    {kind === BookingPostKind.CourseFee ? (
                        <>
                            <div className={css.paymentNumber}>
                                {(position ?? rowIndex) + 1}
                                {"."}
                            </div>
                            <div className={css.monthOfDue}>{moment(payment.paymentDue).format("MMM YY")}</div>
                        </>
                    ) : (
                        <div className={css.monthOfDue}>{rateLabel(payment)}</div>
                    )}
                </div>

                <div className={css.rightContainer}>
                    {/* Bearbeitungsbuttons nur anzeigen, wenn erlaubt */}
                    {showEditControls && (
                        <div className={css.editButtons}>
                            <Button size="small" type="text" style={{color: red[4]}} onClick={() => onDelete(rowIndex)}>
                                <DeleteOutlined />
                            </Button>
                            <Button size="small" type="text" style={{color: blue[5]}} onClick={() => onEdit(rowIndex)}>
                                <EditOutlined />
                            </Button>
                        </div>
                    )}
                    <div className={css.amount}>
                        {/*
                          * Phase 15 / LESSB-03 / D-09 — Mollie-Badge im Preview.
                          * Wird nur angezeigt wenn der SP bereits Mollie-markiert
                          * ist (paymentProvider === Mollie). Fuer neue Preview-SPs
                          * ist paymentProvider undefined — der Badge bleibt
                          * unsichtbar. Der volle 8-State-Badge (paid/open/
                          * method_changed/etc.) folgt in Phase 16 BADGE-01.
                          */}
                        {payment.paymentProvider === PaymentProvider.Mollie && (
                            <PaymentMethodBadge
                                paymentProvider="Mollie"
                                mollieMethod={payment.mollieMethod ?? undefined}
                            />
                        )}
                        {renderAmount({
                            amount: payment.paymentAmount ?? 0,
                            currency: currency.short as Currency,
                        })}
                    </div>
                </div>
            </div>
            <div className={css.secondLine}>
                <div className={css.paymentType}>{kind === BookingPostKind.CourseFee ? rateLabel(payment) : postRowLabel(payment, kind)}</div>
                <div>
                    {"Zahlbar bis "}
                    {moment(payment.paymentDue).format("DD.MM.YY")}
                </div>
            </div>
        </div>
    );
};

export default PaymentItem;
